<template>
	<v-list nav @select="$emit('select')" @click="$emit('click')" dense>
		<div v-for="(group, i) in groups" :key="i">
			<bee-list-group
				color="primary"
				:items="group.items"
				:title="group.name"
				:prepend-icon="group.icon"
			></bee-list-group>
		</div>

		<div v-for="(item, i) in items" :key="i">
			<bee-list-item :item="item" :context="item.context" class="text-body-1"></bee-list-item>
			<v-divider class="my-2 mx-3" v-if="item.with_divider"></v-divider>
		</div>

		<slot></slot>
	</v-list>
</template>

<script>
export default {
	name: "list",
	props: ["groups", "items"]
};
</script>
<style>
.medium-placeholder .v-label {
	font-size: 0.6rem !important;
}
</style>
